// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"3084":"cd97724e","9092":"47b08ab5"}[chunkId] || chunkId) + "." + {"1584":"2e2205abde3ef915","1817":"76045d0db8be622a","3084":"47259c1b975f4d77","9092":"7956ba086b3efbc4"}[chunkId] + ".js";
};